export const baseUrl = process.env.REACT_APP_API_URL;

export const headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
};
